var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAi = function SvgAi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "m12 4-.59 1.92a8.28 8.28 0 0 1-5.5 5.5L4 12l1.92.59c2.63.8 4.69 2.86 5.5 5.5L12 20l.59-1.92a8.28 8.28 0 0 1 5.5-5.5L20 12l-1.92-.59a8.28 8.28 0 0 1-5.5-5.5L12 4Z",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgAi;